@if (editMaterials.length === 0) {
<div class="alert alert-info">
  Dit item heeft nog geen materialen, gebruik onderstaande knop om een materiaal
  toe te voegen
</div>
}
<div class="row">
  <div class="col-12 d-flex align-items-center justify-content-between mb-3">
    <h5 class="bergh-text-primary m-0"></h5>
    @if (allowEdit) {
    <button
      class="btn bergh-btn-secondary text-white"
      (click)="addNewMaterial()"
    >
      Materiaal toevoegen
    </button>
    }
  </div>

  @if (editMaterials.length > 0) {
  <table class="w-100 mx-2 table table-striped card-body">
    <thead>
      <tr>
        <th class="material-type-col" scope="col">Materiaal</th>
        @if (firePartitionType !==
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="eigenschap-col" scope="col">Eigenschap</th>
        } @if (firePartitionType ===
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="specification-text-col" scope="col">Merk</th>
        } @if (firePartitionType ===
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="specification-text-col" scope="col">Type</th>
        } @if (firePartitionType ===
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="date-col" scope="col">Geplaatst op</th>
        } @if (firePartitionType ===
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="date-col" scope="col">Laatste onderhoud</th>
        } @if (firePartitionType ===
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="months-col" scope="col" title="Onderhoud (maanden)">Oh</th>
        }
        <th class="remarks-col" scope="col">Opmerkingen</th>
        @if (firePartitionType ===
        FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
        <th class="status-col" scope="col">Status</th>
        }
        <th class="no-of-units-col" scope="col">Aantal</th>
        @if (allowEdit) {
        <th class="actions-col" scope="col">Acties</th>
        } @if (!allowEdit) {
        <th class="actions-col" scope="col"></th>
        }
        <th scope="col"></th>
      </tr>
    </thead>
    @for (material of editMaterials; track material; let i = $index) {
    <tr>
      <td class="material-type-col border-0 my-auto">
        {{ getMaterialType(material.materialTypeId)?.nameDutch }}
      </td>
      @if (firePartitionType !==
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="eigenschap-col border-0 my-auto">
        @if (material.materialSpecificationName) {
        <span>
          {{ material.materialSpecificationName }}
        </span>
        }
        {{ material.materialSpecificationText }}
      </td>
      } @if (firePartitionType ===
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="specification-text-col border-0 my-auto">
        {{ material.materialSpecificationBrand }}
      </td>
      } @if (firePartitionType ===
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="specification-text-col border-0 my-auto">
        {{ material.materialSpecificationText }}
      </td>
      } @if (firePartitionType ===
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="date-col border-0 my-auto">
        {{ formatDate(material.materialPlacedDate) }}
      </td>
      } @if (firePartitionType ===
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="date-col border-0 my-auto">
        {{ formatDate(material.materialMaintenanceDate) }}
      </td>
      } @if (firePartitionType ===
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="months-col border-0 my-auto">
        {{ material.materialMaintenanceIntervalMonths }}
      </td>
      }
      <td class="remarks-col border-0 my-auto">
        {{ material.materialRemarks }}
      </td>
      @if (firePartitionType ===
      FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
      <td class="date-col border-0 my-auto">
        {{
          material.materialStatus
            ? MATERIAL_STATUSES.get(material.materialStatus)?.nameDutch
            : "-"
        }}
      </td>
      }
      <td class="no-of-units-col border-0 my-auto">
        {{ material.noOfUnits }}
      </td>
      @if (allowEdit) {
      <td class="actions-col btn-delete border-0 my-auto">
        <button
          class="btn btn-secondary ml-2 edit-btn"
          (click)="editMaterial(i)"
          title="Bewerken"
        >
          <i-feather name="edit"></i-feather>
        </button>
        <button
          class="btn btn-secondary ml-2 edit-btn"
          (click)="removeMaterial(i)"
          title="Verwijderen"
        >
          <i-feather name="trash-2"></i-feather>
        </button>
      </td>
      }
    </tr>
    }
  </table>
  }
</div>

@if (isEditMaterialModalOpen) {
<bergh-edit-material-modal
  [material]="editedMaterial"
  [materialPosition]="editedPosition"
  [materialTypes]="materialTypes"
  [firePartitionType]="firePartitionType"
  (save)="onSaveMaterial($event)"
  (cancel)="onCancelModal()"
></bergh-edit-material-modal>
}
